import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

const HomePage = React.lazy(() => import('./pages/HomePage'));
const RoomBookingSystem = React.lazy(() => import('./pages/TVVL_RoomBookingSystem'));
const EnvironmentalDashboard = React.lazy(() => import('./pages/TVVL_EnvironmentalDashboard'));
const TvvlEnergyDashboard = React.lazy(() => import('./pages/TVVL_EnergyDashboard'));
const TnEnergyDashboard = React.lazy(() => import('./pages/TN_EnergyDashboard'));
const Testing = React.lazy(() => import('./pages/testing'));

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Laden...</div>}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tvvl-roombooking" element={<RoomBookingSystem />} />
            <Route path="/tvvl-enviromental" element={<EnvironmentalDashboard />} />
            <Route path="/tvvl-energy" element={<TvvlEnergyDashboard />} />
            <Route path="/tn-energy" element={<TnEnergyDashboard />} />
            <Route path="/testing" element={<Testing />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
};

export default App;
